import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import bg1 from "../../../assets/images/signup.jpg";
import { fetchlogo } from "../../../ApiService/logo/logo";
import { signupUser } from "../../../ApiService/signupapi/signupapi";
import BackToHome from "../../../components/back-to-home";
import Switcher from "../../../components/switcher";
import toast from "react-hot-toast";

export default function Signup() {
  const BASE_MEDIA_URL = process.env.REACT_APP_MEDIA_BASE_URL;
  const [logos, setlogos] = useState([]);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    termsAccepted: false,
  });
  const [errors, setErrors] = useState({
    first_name: false,
    last_name: false,
    email: false,
    password: false,
    termsAccepted: false,
  });
  const navigate = useNavigate();

  // ✅ Fetch logo
  useEffect(() => {
    const getlogo = async () => {
      try {
        const Logos = await fetchlogo();
        setlogos(Logos[0]);
      } catch (err) {
        console.error("Failed to load logo:", err);
      }
    };
    getlogo();
  }, []);

  // ✅ Handle Input Change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: false
      });
    }
  };

  // ✅ Validate Form
  const validateForm = () => {
    const newErrors = {
      first_name: !formData.first_name.trim(),
      last_name: !formData.last_name.trim(),
      email: !formData.email.trim(),
      password: !formData.password.trim(),
      termsAccepted: !formData.termsAccepted,
    };

    setErrors(newErrors);

    // Return true if there are no errors
    return !Object.values(newErrors).some(error => error);
  };

  // ✅ Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (!validateForm()) {
      toast.error("Please fill in all required fields", {
        position: "top-center",
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        }
      });
      return;
    }

    try {
      const response = await signupUser({
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        password: formData.password,
      });

      console.log("Signup Success:", response);
      if (response && response.access && response.refresh) {
        localStorage.setItem("userData", JSON.stringify(response));
      }
      navigate("/signup-success"); // redirect on success
    } catch (error) {
      console.log("Signup Failed:", error);
      toast.error("Signup failed. Please try again.", {
        position: "top-center",
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        }
      });
    }
  };

  return (
    <>
      <section className="md:h-screen py-36 flex items-center bg-orange-500/10 dark:bg-orange-500/20 bg-[url('../../assets/images/hero/bg-shape.png')] bg-center bg-no-repeat bg-cover">
        <div className="container relative">
          <div className="grid grid-cols-1">
            <div className="relative overflow-hidden rounded-md shadow dark:shadow-gray-700 bg-white dark:bg-slate-900">
              <div className="grid md:grid-cols-2 grid-cols-1 items-center">
                <div className="relative md:shrink-0">
                  <img className="h-full w-full object-cover md:h-[44rem]" src={bg1} alt="" />
                </div>

                <div className="p-8 lg:px-20">
                  <div className="text-center">
                    {logos?.header_logo ? (
                      <img
                        src={`${BASE_MEDIA_URL}${logos.header_logo}`}
                        className="h-[110px] w-[180px]"
                        alt="logo"
                        onError={(e) => {
                          e.target.style.display = "none";   // hide broken image
                          e.target.parentNode.innerHTML = "Spotyfi";
                        }}
                      />
                    ) : (
                      <span>Spotyfi</span>
                    )}
                  </div>

                  {/* ✅ Signup Form */}
                  <form className="text-start lg:py-20 py-8" onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1">
                      {/* First and Last Name Side by Side */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                          <label className="font-semibold" htmlFor="RegisterFirstName">
                            First Name:
                          </label>
                          <input
                            id="RegisterFirstName"
                            name="first_name"
                            type="text"
                            value={formData.first_name}
                            onChange={handleChange}
                            className={`mt-3 w-full py-2 px-3 h-10 bg-transparent border rounded outline-none ${errors.first_name ? 'border-red-500' : 'border-gray-100'}`}
                            placeholder="First Name"
                          />
                        </div>
                        <div>
                          <label className="font-semibold" htmlFor="RegisterLastName">
                            Last Name:
                          </label>
                          <input
                            id="RegisterLastName"
                            name="last_name"
                            type="text"
                            value={formData.last_name}
                            onChange={handleChange}
                            className={`mt-3 w-full py-2 px-3 h-10 bg-transparent border rounded outline-none ${errors.last_name ? 'border-red-500' : 'border-gray-100'}`}
                            placeholder="Last Name"
                          />
                        </div>
                      </div>

                      <div className="mb-4">
                        <label className="font-semibold" htmlFor="LoginEmail">
                          Email Address:
                        </label>
                        <input
                          id="LoginEmail"
                          name="email"
                          type="email"
                          value={formData.email}
                          onChange={handleChange}
                          className={`mt-3 w-full py-2 px-3 h-10 bg-transparent border rounded outline-none ${errors.email ? 'border-red-500' : 'border-gray-100'}`}
                          placeholder="name@example.com"
                        />
                      </div>

                      <div className="mb-4">
                        <label className="font-semibold" htmlFor="LoginPassword">
                          Password:
                        </label>
                        <input
                          id="LoginPassword"
                          name="password"
                          type="password"
                          value={formData.password}
                          onChange={handleChange}
                          className={`mt-3 w-full py-2 px-3 h-10 bg-transparent border rounded outline-none ${errors.password ? 'border-red-500' : 'border-gray-100'}`}
                          placeholder="Password"
                        />
                      </div>

                      <div className="mb-4">
                        <div className="flex items-center w-full mb-0">
                          <input
                            name="termsAccepted"
                            checked={formData.termsAccepted}
                            onChange={handleChange}
                            className={`form-checkbox rounded me-2 ${errors.termsAccepted ? 'border-red-500 text-red-500' : 'border-gray-100 text-green-500'}`}
                            type="checkbox"
                            id="AcceptT&C"
                          />
                          <label className="form-check-label text-slate-400" htmlFor="AcceptT&C">
                            I Accept{" "}
                            <Link to="" className="text-green-500">
                              Terms And Condition
                            </Link>
                          </label>
                        </div>
                      </div>

                      <div className="mb-4">
                        <button
                          type="submit"
                          className="py-2 px-5 inline-block bg-green-500 text-white rounded-md w-full"
                        >
                          Register
                        </button>
                      </div>

                      <div className="text-center">
                        <span className="text-slate-400 me-2">Already have an account?</span>{" "}
                        <Link to="/login" className="text-black dark:text-white font-bold inline-block">
                          Sign in
                        </Link>
                      </div>
                    </div>
                  </form>

                  <div className="text-center">
                    <p className="mb-0 text-slate-400">
                      © {new Date().getFullYear()} Sportyfi. Design & Develop with{" "}
                      <i className="mdi mdi-heart text-red-600"></i> by{" "}
                      <Link to="https://www.vichaarlab.com/" target="_blank" className="text-reset">
                        Vichaarlab
                      </Link>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <BackToHome />
      <Switcher />
    </>
  );
}